export function hasWindow() {
  return typeof window !== 'undefined';
}
